import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { getName } from '../gallery.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const values = new WeakMap()

const type = click
const onClick = object(listener, {
  type,
  passive,
  task: (
    element
  ) => {
    const name = getName(element)
    if (name) {
      let new_val = 1
      if (values.has(element)) {
        const val = values.get(element)
        new_val = (val + 1) % 3
      }
      window.ea_rainbow_quality(name, new_val)
      values.set(element, new_val)
    }
  }
})

export default element => {
  onClick.listen(element)
}
